import Vue from 'vue';

export default {

    SET_SEARCHTERM (state, searchTerm) {
      state.searchTerm = searchTerm
    },
    SET_ASSETS(state, assets){
      assets.map(asset=>{
        state.imageAssets[asset.key] = asset.file;
      })
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js